import { getTvObject, tv } from '@costar-ui/cosmos';
import { focusRing } from '../../../theme/styles/common.esm.js';

var outerRadioCircleTvObject = getTvObject({
  extend: focusRing,
  base: ['csg-tw-radio', 'size-4', 'rounded-full', 'p-2', 'border', 'relative', 'border-action-neutral', focusRing.base],
  variants: {
    isFocusVisible: {
      "false": focusRing.variants.isFocusVisible["false"],
      "true": focusRing.variants.isFocusVisible["true"]
    },
    isHovered: {
      "true": 'border-hover'
    },
    isSelected: {
      "true": 'border-selected'
    },
    isDisabled: {
      "true": 'border-disabled bg-action-disabled'
    }
  },
  compoundVariants: [{
    isSelected: true,
    isDisabled: true,
    className: 'border-disabled bg-action-disabled'
  }]
});
var outerRadioCircleStyles = tv(outerRadioCircleTvObject);

export { outerRadioCircleStyles, outerRadioCircleTvObject };
//# sourceMappingURL=outer-radio-circle.styles.esm.js.map
